import { withTranslation } from "react-i18next";
import { compose, withHandlers } from "recompose";
import { connect } from "react-redux";
import { withPairingRequester } from "src/modules/pairing-requester/PairingRequester";

import { handlePairingCancelation } from "../../duck/epics";
import { getResponder } from "../../duck/selectors";
import DevicesOnly from "./DevicesOnly";
import getDeviceIcon from "src/icons/device/getDeviceIcon";

function mapStateToProps(state) {
  try {
    const { name, jid } = getResponder(state);
    return {
      deviceName: name,
      icon: getDeviceIcon(jid)
    };
  } catch (err) {
    return {
      deviceName: "",
      icon: getDeviceIcon("")
    };
  }
}

const enhance = compose(
  connect(mapStateToProps, (dispatch, { flow, closeWizard }) => ({
    onReject: () => dispatch(handlePairingCancelation({ flow })),
    onClose: () => dispatch(handlePairingCancelation({ closeWizard }))
  })),
  withPairingRequester,
  withHandlers({
    onPair:
      ({ flow, pairingRequester }) =>
      () => {
        flow.push("waiting");
        pairingRequester.sendRequestMessage();
      }
  }),

  withTranslation()
);

export default enhance(DevicesOnly);
